import React, { useState } from "react";
import { Link } from "react-router-dom";
import { DatePicker } from "react-advance-jalaali-datepicker";
import moment from "moment";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { Button, Modal } from "react-bootstrap";
import ExportJsonExcel from "js-export-excel";
import Sidebar from "../../partials/aside/Sidebar";
import TitleBar from "../../partials/content/TitleBar";
import helperSpinner from "../../../helpers/spinner";
import helpersNumbers from "../../../helpers/numbers";
import helpersTime from "../../../helpers/time";
import messageCategoryUserSitePublishers from "../../../messages/category-user-site-publishers";
import AutoCategoryUserSitePublisher from "./auto-category-user-site-publisher";
import ButtonDisable from "../../partials/other/ButtonDisable";

export default function AddGroupSitePublisherAutomate() {
  const [message, setMessage] = useState();
  const history = useHistory();
  const [dataSitePublisher, setDataSitePublisher] = useState();
  const [amount, setAmount] = useState(100000);
  const [
    confirmCategoryUserSitePublisher,
    setConfirmCategoryUserSitePublisher,
  ] = useState(false);
  const [
    showModalPositionsOnCategoryUserSitePublisher,
    setShowModalPositionsOnCategoryUserSitePublisher,
  ] = useState(false);

  const handleCloseModalPositionsOnCategoryUserSitePublisher = () =>
    setShowModalPositionsOnCategoryUserSitePublisher(false);
  const handleShowModalPositionsOnCategoryUserSitePublisher = () =>
    setShowModalPositionsOnCategoryUserSitePublisher(true);

  const startDate = moment(helpersTime.getDateNow())
    .add(1, "days")
    .format("YYYY/M/D");
  const endDate = moment(helpersTime.getDateNow())
    .add(2, "days")
    .format("YYYY/M/D");

  let messageTag;
  if (message) {
    messageTag = (
      <div key={Math.random()} className={`${message.type_class}`}>
        <i className={`${message.class_icon} pl-2`}></i>
        <span>{message.text}</span>
      </div>
    );
  }

  const inputAmountChangeHandler = (e) => {
    let number = e.target.value;
    number = helpersNumbers.toEnglishNumber(number.replaceAll(",", ""));
    if (number == "") {
      number = 0;
    }
    setAmount(parseInt(number));
  };

  const inputAmountBeforeInputHandler = (e) => {
    const regexLetter = new RegExp("^[0-9\b]+$");
    if (!regexLetter.test(e.data)) {
      e.preventDefault();
      return;
    }
  };

  const checkStartDateEntered = (startDateEntered) => {
    startDateEntered = helpersTime.convertJalaliToGregorian(startDateEntered);
    if (moment(startDateEntered).diff(startDate, "d") < 0) {
      setMessage({
        type_class: "alert alert-danger",
        text: messageCategoryUserSitePublishers.START_DATE_IS_PAST_FROM_CURRENT_DATE,
        class_icon: "fa fa-exclamation-triangle",
      });
      return false;
    }

    let currentDate = moment(new Date().toISOString().split("T")[0]);
    const differentDates = moment(startDateEntered).diff(currentDate, "days");
    let maxCountDaysCategoryUserSitePublisherForStartDate =
      parseInt(
        process.env.REACT_APP_MAX_COUNT_DAYS_CATEGORY_USER_SITE_PUBLISHER
      ) - 1;
    if (differentDates > maxCountDaysCategoryUserSitePublisherForStartDate) {
      setMessage({
        type_class: "alert alert-danger",
        text: messageCategoryUserSitePublishers.START_DATE_IS_TOO_MUCH,
        class_icon: "fa fa-exclamation-triangle",
      });

      return false;
    }

    return true;
  };

  const checkEndDateEntered = (endDateEntered, startDateEntered) => {
    endDateEntered = helpersTime.convertJalaliToGregorian(endDateEntered);

    if (moment(endDateEntered).diff(endDate, "d") < 0) {
      setMessage({
        type_class: "alert alert-danger",
        text: messageCategoryUserSitePublishers.END_DATE_IS_PAST_FROM_START_DATE,
        class_icon: "fa fa-exclamation-triangle",
      });
      return false;
    }

    if (
      moment(endDateEntered).diff(
        moment(helpersTime.convertJalaliToGregorian(startDateEntered)),
        "d"
      ) < 0
    ) {
      setMessage({
        type_class: "alert alert-danger",
        text: messageCategoryUserSitePublishers.END_DATE_IS_PAST_FROM_START_DATE,
        class_icon: "fa fa-exclamation-triangle",
      });
      return false;
    }

    let currentDate = moment(new Date().toISOString().split("T")[0]);
    const differentDates = moment(endDateEntered).diff(currentDate, "days");
    if (
      differentDates >
      parseInt(
        process.env.REACT_APP_MAX_COUNT_DAYS_CATEGORY_USER_SITE_PUBLISHER
      )
    ) {
      setMessage({
        type_class: "alert alert-danger",
        text: messageCategoryUserSitePublishers.END_DATE_IS_TOO_MUCH,
        class_icon: "fa fa-exclamation-triangle",
      });
      return false;
    }

    return true;
  };

  const showInfoCategoryUserSitePublisher = () => {
    return (
      <div className="pt-2">
        {showInformationCategoryUserSitePublisher()}
        <div className="py-2 d-flex flex-column flex-lg-row">
          <div className="pb-2 pb-lg-0 pl-lg-2">
            <span
              className="btn btn-success"
              onClick={() => {
                exportReportExcel(dataSitePublisher);
              }}
            >
              خروجی فایل excel
            </span>
          </div>

          <div className="">
            <span
              className="btn btn-primary"
              onClick={() => {
                handleShowModalPositionsOnCategoryUserSitePublisher();
              }}
            >
              نمایش جایگاه های انتخاب شده
            </span>
          </div>
        </div>

        <div className="alert alert-warning">
          در صورت مشاهده و تایید جایگاه های گروه نمایش دهنده بصورت فایل excel به
          وسیله دکمه زیر گروه نمایش دهنده را اضافه کنید.
        </div>
        <div>
          <ButtonDisable
            buttonTagHtml={
              <span className="btn btn-success opacity-50">اضافه کردن</span>
            }
          />
          {/* <button className="btn btn-success">
            اضافه کردن گروه نمایش دهنده
          </button> */}
        </div>
      </div>
    );
  };

  const getCategoryUserSitePublisher = async () => {
    const categoryName = document.querySelector("#name").value;
    const startDateEntered = document.querySelector(".start-date input").value;
    const endDateEntered = document.querySelector(".end-date input").value;

    if (!categoryName) {
      setMessage({
        type_class: "alert alert-danger",
        text: messageCategoryUserSitePublishers.NAME_DOSE_NOT_EXIST,
        class_icon: "fa fa-exclamation-triangle",
      });
      helperSpinner.scrollForSeeMessage(".card");
      return;
    }

    if (!checkStartDateEntered(startDateEntered)) {
      helperSpinner.scrollForSeeMessage(".card");
      return;
    }
    if (!checkEndDateEntered(endDateEntered, startDateEntered)) {
      helperSpinner.scrollForSeeMessage(".card");
      return;
    }

    setDataSitePublisher(AutoCategoryUserSitePublisher);
    setConfirmCategoryUserSitePublisher(true);
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const exportReportExcel = (dataSitePublisher) => {
    const newDataSitePublisher = { ...dataSitePublisher.positions };

    const startDateJalali = helpersTime.convertGregorianToJalali(startDate);
    const endDateJalali = helpersTime.convertGregorianToJalali(endDate);

    var option = new Object();
    option.fileName = document.querySelector("#name").value;

    let dataExcelFile = [
      {
        one: "عنوان گروه ",
        two: document.querySelector("#name").value + "",
      },
      {
        one: "مبلغ گروه نمایش دهنده در یک شبانه روز (تومان)",
        two: helpersNumbers.toPersianNum(
          helpersNumbers.toFormatFinanceNumber(
            getPriceCategoryUserSitePublisher(newDataSitePublisher)
          )
        ),
      },
      {
        one: "تاریخ شروع",
        two: helpersNumbers.toPersianNum(startDateJalali),
        three: "تاریخ پایان",
        four: helpersNumbers.toPersianNum(endDateJalali),
      },
      {
        one: "=======================",
        two: "=======================",
      },
    ];

    for (let key in newDataSitePublisher) {
      dataExcelFile = [
        ...dataExcelFile,
        ...generateEachSitePublisherArrayReportExportExcel(
          newDataSitePublisher[key]
        ),
        {
          one: "=======================",
          two: "=======================",
        },
      ];
    }

    option.datas = [
      {
        sheetData: dataExcelFile,
        columnWidths: [10, 10],
      },
    ];

    const toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
    dataExcelFile = [];
  };

  const generatePageDataReportExportExcel = (pageDataReport) => {
    return [
      {
        one: pageDataReport.title,
        two: helpersNumbers.toPersianNum(
          helpersNumbers.toFormatFinanceNumber(pageDataReport.price)
        ),
      },
      { ...pageDataReport.positions },
      { one: "", two: "" },
    ];
  };

  const getPriceSitePublisher = (priceSitePublisher) => {
    let pricePage = 0;
    const newSitePublisherData = { ...priceSitePublisher };
    for (const key in newSitePublisherData) {
      if (key === "url") {
        continue;
      }
      pricePage = pricePage + newSitePublisherData[key].price;
    }
    return pricePage;
  };

  const getPriceCategoryUserSitePublisher = (sitePublisherData) => {
    let priceCategoryUserSitePublisher = 0;
    for (let key in sitePublisherData) {
      priceCategoryUserSitePublisher += getPriceSitePublisher(
        sitePublisherData[key]
      );
    }
    return priceCategoryUserSitePublisher;
  };

  const generateEachSitePublisherArrayReportExportExcel = (
    sitePublisherDataParam
  ) => {
    let sitePublisherUrl = sitePublisherDataParam.url;

    let dataEachSitePublisherExcelFile = [
      {
        one: sitePublisherUrl,
        two: helpersNumbers.toPersianNum(
          helpersNumbers.toFormatFinanceNumber(
            getPriceSitePublisher(sitePublisherDataParam)
          )
        ),
      },
    ];

    for (const key in sitePublisherDataParam) {
      if (key === "url") {
        continue;
      }

      const item = sitePublisherDataParam[key];
      dataEachSitePublisherExcelFile = [
        ...dataEachSitePublisherExcelFile,
        ...generatePageDataReportExportExcel(item),
      ];
    }

    return dataEachSitePublisherExcelFile;
  };

  const generatePositionBox = (positions) => {
    return positions.map((position, index) => {
      return (
        <div
          key={index}
          className="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 select-position-in-page-box py-2"
        >
          <div className="bg-primary">
            <div className="p-2 d-flex">
              <div className="align-items-center justify-content-center d-flex flex-grow-1">
                <span>اطلاعات جایگاه</span>
                <span className="px-2">-</span>
                <span className="letter-spacing-finance-number">
                  {helpersNumbers.toPersianNum(
                    position.tag_html_id.replace(
                      process.env.REACT_APP_PREFIX_POSITION_TAG_HTML_ID,
                      ""
                    )
                  )}
                </span>
              </div>
            </div>

            <div className=" d-flex border-top">
              <div className="py-2 w-50 text-center border-left">اندازه</div>
              <div className="py-2 w-50 text-center">
                <span className="letter-spacing-finance-number" dir="ltr">
                  {helpersNumbers.toPersianNum(position.size.replace("-", "×"))}
                </span>
                <span className="pr-2">پیکسل</span>
              </div>
            </div>

            <div className=" d-flex border-top">
              <div className="py-2 w-50 text-center border-left">ظرفیت کل</div>
              <div className="py-2 w-50 text-center">
                {helpersNumbers.toPersianNum(position.count)}
                <span className="pr-2">بنر</span>
              </div>
            </div>
            <div className=" d-flex border-top">
              <div className="py-2 w-50 text-center border-left">سهم شما</div>
              <div className="py-2 w-50 text-center">
                {helpersNumbers.toPersianNum(1)}
                <span className="pr-2">بنر</span>
              </div>
            </div>

            <div className=" d-flex border-top">
              <div className="py-2 w-50 text-center border-left">ارزش کل</div>
              <div className="py-2 w-50 text-center ">
                <span className="letter-spacing-finance-number">
                  {helpersNumbers.toPersianNum(
                    helpersNumbers.toFormatFinanceNumber(position.base_price)
                  )}
                </span>
                <span className="pr-2">تومان</span>
              </div>
            </div>

            <div className=" d-flex border-top">
              <div className="py-2 w-50 text-center border-left">
                پرداختی شما
              </div>
              <div className="py-2 w-50 text-center ">
                <span className="letter-spacing-finance-number">
                  {helpersNumbers.toPersianNum(
                    helpersNumbers.toFormatFinanceNumber(position.price)
                  )}
                </span>

                <span className="pr-2">تومان</span>
              </div>
            </div>

            <div className="px-2 d-flex border-top">
              <div className="py-2 w-50 text-center border-left">سهم نمایش</div>
              <div className="py-2 w-50 text-center ">
                <span className="letter-spacing-finance-number">
                  {helpersNumbers.toPersianNum(
                    Math.floor((1 / position.count) * 100)
                  )}
                </span>
                <span className="pr-2">درصد</span>
              </div>
            </div>

            <div dir="ltr" className="p-2 text-center border-top">
              {position.tag_html_id}
            </div>
          </div>
        </div>
      );
    });
  };

  const calculatePriceSite = (sitePublisherData) => {
    let pricePage = 0;

    for (let pageID in sitePublisherData) {
      if (pageID === "url") {
        continue;
      }
      pricePage += sitePublisherData[pageID].price;
    }
    return pricePage;
  };

  const showPositionOnCategoryUserSitePublisherOnModalBody = () => {
    const groupUserSitePublisherDataSites = dataSitePublisher.positions;

    let tagCollection = [];
    for (const sitePublisherID in groupUserSitePublisherDataSites) {
      const sitePublisherData =
        groupUserSitePublisherDataSites[sitePublisherID];
      tagCollection.push(
        <div className="py-2">
          <div
            className="border border-2 border-warning bg-warning rounded"
            style={{ height: "5px" }}
          ></div>
          <span>سایت : </span>
          <span>
            <a target="_blank" href={sitePublisherData.url}>
              {sitePublisherData.url}
            </a>
          </span>
          <span className="pr-1">-</span>
          <span className="pr-1">قیمت سایت : </span>
          <span className="letter-spacing-finance-number">
            {helpersNumbers.toPersianNum(
              helpersNumbers.toFormatFinanceNumber(
                calculatePriceSite(sitePublisherData)
              )
            )}
          </span>
          <span className="pr-1"> تومان</span>
        </div>
      );
      for (const sitePublisherID in sitePublisherData) {
        if (sitePublisherID === "url") {
          continue;
        }
        const pageData = sitePublisherData[sitePublisherID];
        tagCollection.push(
          <>
            <div className="d-flex">
              <div>عنوان صفحه : </div>
              <div>{pageData.title}</div>
              <div className="pr-1">-</div>
              <div className="pr-1">قیمت صفحه :</div>
              <div className="letter-spacing-finance-number">
                {helpersNumbers.toPersianNum(
                  helpersNumbers.toFormatFinanceNumber(pageData.price)
                )}
              </div>
              <div className="pr-1"> تومان</div>
            </div>
            <div className="container-fluid" id="select-position-container">
              <div className="row">
                {generatePositionBox(pageData.positions_report)}
              </div>
            </div>
          </>
        );
      }
    }
    return tagCollection;
  };

  const showInformationCategoryUserSitePublisher = () => {
    return (
      <div className="table-responsive">
        <table className="table table-hilite tbl-td-white-space table-hover m-0">
          <thead>
            <tr>
              <td
                colspan="2"
                className="text-center"
                style={{ borderRadius: "25px 25px 0px 0px" }}
              >
                <b>اطلاعات گروه نمایش دهنده</b>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <label className="pl-1">تاریخ شروع</label>
              </td>
              <td>
                <span className="number-finance">
                  <label className="pr-2" dir="ltr">
                    {helpersNumbers.toPersianNum(
                      document.querySelector(".start-date input").value
                    )}{" "}
                    ۰۰:۰۰
                  </label>
                </span>
              </td>
            </tr>
            <tr>
              <td>
                <label className="pl-1">تاریخ پایان</label>
              </td>
              <td>
                <span className="number-finance">
                  <label className="pr-2" dir="ltr">
                    {helpersNumbers.toPersianNum(
                      document.querySelector(".end-date input").value
                    )}{" "}
                    ۲۳:۵۹
                  </label>
                </span>
              </td>
            </tr>

            <tr>
              <td>
                <label>تعداد سایت</label>
              </td>
              <td>
                <span>
                  <label className="letter-spacing-finance-number">
                    {helpersNumbers.toPersianNum(
                      dataSitePublisher.count_site_publisher
                    )}
                  </label>
                </span>
              </td>
            </tr>

            <tr>
              <td>
                <label>تعداد جایگاه ها</label>
              </td>
              <td>
                <span>
                  <label className="letter-spacing-finance-number">
                    {helpersNumbers.toPersianNum(
                      dataSitePublisher.count_positions
                    )}
                  </label>
                </span>
              </td>
            </tr>

            <tr>
              <td>
                <label>مبلغ یک شبانه روز گروه نمایش دهنده</label>
              </td>
              <td>
                <span>
                  <label className="letter-spacing-finance-number">
                    {helpersNumbers.toPersianNum(
                      helpersNumbers.toFormatFinanceNumber(amount)
                    )}
                  </label>
                  <label className="pr-2">تومان</label>
                </span>
              </td>
            </tr>

            <tr>
              <td>
                <label>تعداد شبانه روز گروه نمایش دهنده</label>
              </td>
              <td>
                <span>
                  <label>
                    {helpersNumbers.toPersianNum(
                      moment(
                        document.querySelector(".end-date input").value
                      ).diff(
                        moment(
                          document.querySelector(".start-date input").value
                        ),
                        "days"
                      ) + 1
                    )}
                  </label>
                  <label className="pr-2">شبانه روز</label>
                </span>
              </td>
            </tr>
            <tr>
              <td>
                <label>مبلغ گروه نمایش دهنده</label>
              </td>
              <td>
                <span>
                  <label className="letter-spacing-finance-number">
                    {helpersNumbers.toPersianNum(
                      helpersNumbers.toFormatFinanceNumber(
                        (moment(
                          document.querySelector(".end-date input").value
                        ).diff(
                          moment(
                            document.querySelector(".start-date input").value
                          ),
                          "days"
                        ) +
                          1) *
                          amount
                      )
                    )}
                  </label>
                  <label className="pr-2">تومان</label>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  };

  const sendForm = (e) => {
    e.preventDefault();
  };

  return (
    <>
      <Sidebar />
      <div className="content-wrapper">
        <TitleBar title="اضافه کردن گروه سایت های نمایش دهنده خودکار" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              <div className="text-left pb-2">
                <Link to="/publishers/all" className="btn btn-success">
                  <span>بازگشت</span>
                  <span className="pr-2">
                    <i className="fas fa-arrow-left"></i>
                  </span>
                </Link>
              </div>

              <>
                {messageTag}
                <div className="alert alert-warning">
                  <p className="text-justify">
                    <i className="fa fa-info pl-2"></i>
                    توجه داشته باشید :{" "}
                  </p>
                  <ul className="pr-3">
                    <li>
                      <p className="text-justify">
                        ساعت تاریخ شروع از ۰۰:۰۰ و ساعت تاریخ پایان از ۲۳:۵۹
                      </p>
                    </li>
                    <li>
                      <p className="text-justify">
                        {" "}
                        به طور مثال : تاریخ شروع ۰۰:۰۰ ۱۴۰۰/۴/۲ و تاریخ پایان
                        ۲۳:۵۹ ۱۴۰۰/۴/۲۰
                      </p>
                    </li>
                    <li>
                      <p className="text-justify">
                        تاریخ شروع گروه بنری سایت های نمایش دهنده شما باید در
                        بازه یک روز بعد از تاریخ جاری تا ۸۹ روز بعد
                      </p>
                    </li>
                    <li>
                      <p className="text-justify">
                        تاریخ پایان گروه بنری سایت های نمایش دهنده شما باید در
                        بازه دو روز بعد از تاریخ جاری تا ۹۰ روز بعد باشد
                      </p>
                    </li>
                    <li>
                      <p className="text-justify">
                        به طور مثال : تاریخ جاری ۱۴۰۰/۷/۱
                      </p>
                    </li>
                    <li>
                      <p className="text-justify">
                        بازه مجاز برای تاریخ شروع ۱۴۰۰/۷/۲ - ۱۴۰۰/۹/۲۹- دو روز
                        ۷/۲ و ۹/۲۹ جزیی از این بازه هستن که ۸۹ روز میشود
                      </p>
                    </li>
                    <li>
                      <p className="text-justify">
                        بازه مجاز برای تاریخ پایان ۱۴۰۰/۷/۳ - ۱۴۰۰/۱۰/۲- دو روز
                        ۷/۳ و ۱۰/۲ جزیی از این بازه هستن که ۹۰ روز میشود
                      </p>
                    </li>
                    <li>
                      <p className="text-justify">
                        توجه داشته باشید که ۶ ماه ابتدا سال ۳۱ روزه و اسفند ماه
                        ۲۹ روز است.
                      </p>
                    </li>
                    <li>
                      <p className="text-justify">
                        قبل از اضافه کردن گروه , حتما به وسیله دکمه سبز رنگ
                        پایین سمت چپ یک گزارش از سایت ها , صفحات , جایگاه های
                        تبلیغاتی انتخاب شده بگیرید.
                      </p>
                    </li>
                  </ul>
                </div>

                <form onSubmit={sendForm}>
                  <div className="form-group">
                    <label>نام گروه</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="نام گروه"
                      id="name"
                      required
                    />
                  </div>

                  <div className="form-group">
                    <div className="container-fluid p-0">
                      <div className="row align-items-end">
                        <div className="col-12 col-md-6">
                          <div>
                            <div>
                              <label>تاریخ شروع</label>
                            </div>
                            <div className="custom-data-picker start-date">
                              <DatePicker
                                placeholder="انتخاب تاریخ"
                                format="jYYYY/jMM/jDD"
                                preSelected={helpersTime.convertGregorianToJalali(
                                  startDate
                                )}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-12 col-md-6">
                          <div>
                            <div>
                              <label>تاریخ پایان</label>
                            </div>
                            <div className="custom-data-picker end-date">
                              <DatePicker
                                placeholder="انتخاب تاریخ"
                                format="jYYYY/jMM/jDD"
                                preSelected={helpersTime.convertGregorianToJalali(
                                  endDate
                                )}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-12 col-md-6 ">
                          <div>
                            <div>
                              <b>مبلغ گروه نمایش دهنده در یک شبانه روز</b>
                            </div>
                            <div>
                              <div className="input-group">
                                <input
                                  type="text"
                                  id="amount"
                                  className="form-control number-finance"
                                  value={helpersNumbers.toPersianNum(
                                    helpersNumbers.toFormatFinanceNumber(amount)
                                  )}
                                  onChange={inputAmountChangeHandler}
                                  onBeforeInput={inputAmountBeforeInputHandler}
                                  dir="ltr"
                                />
                                <div className="input-group-append">
                                  <span className="input-group-text">
                                    تومان
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-12 col-md-6 pt-3 pt-md-0">
                          <span
                            className="btn btn-primary w-100"
                            onClick={getCategoryUserSitePublisher}
                          >
                            نمایش اطلاعات گروه نمایش دهنده
                          </span>
                        </div>
                      </div>
                    </div>
                    {confirmCategoryUserSitePublisher &&
                      showInfoCategoryUserSitePublisher()}
                  </div>
                </form>
              </>
            </div>
          </div>
        </section>
      </div>

      {confirmCategoryUserSitePublisher && (
        <Modal
          size="lg"
          show={showModalPositionsOnCategoryUserSitePublisher}
          onHide={handleCloseModalPositionsOnCategoryUserSitePublisher}
        >
          <Modal.Body>
            {showPositionOnCategoryUserSitePublisherOnModalBody()}
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="btn btn-warning"
              onClick={handleCloseModalPositionsOnCategoryUserSitePublisher}
            >
              بستن
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </>
  );
}
